
import StyleClassNamesBuilder from '../../../../../styles/helpers/StyleClassNamesBuilder';
import { StyleColorSchemeType } from '../../../../../styles/enums';
import { RatingEventType, RatingItemPropertyType } from './enums';
import Icon from '../../../../icon';
import RatingItemProps from './mixins/RatingItemProps';

export default {
  name: 'RatingItem',
  components: {
    Icon,
  },
  mixins: [
    RatingItemProps,
  ],
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      RatingItemPropertyType,
    };
  },
  computed: {
    ratingItemClassNames() {
      return new StyleClassNamesBuilder('rating-item')
        .addConditionClassName('disabled', this[RatingItemPropertyType.Disabled])
        .build();
    },
    icon() {
      return this.checked
        ? this[RatingItemPropertyType.CheckedIcon]
        : this[RatingItemPropertyType.UncheckedIcon];
    },
    color() {
      return this[RatingItemPropertyType.Disabled]
        ? StyleColorSchemeType.GrayLight
        : this[RatingItemPropertyType.ColorScheme];
    },
  },
  methods: {
    handleChange() {
      this.$emit(RatingEventType.Change, this[RatingItemPropertyType.Value]);
    },
  },
};
